import { render, staticRenderFns } from "./BDdy.vue?vue&type=template&id=62ef8a62&scoped=true"
import script from "./BDdy.vue?vue&type=script&lang=js"
export * from "./BDdy.vue?vue&type=script&lang=js"
import style0 from "./BDdy.vue?vue&type=style&index=0&id=62ef8a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef8a62",
  null
  
)

export default component.exports